import React from "react"
import { graphql } from "gatsby"
import styled from 'styled-components'

import Layout from "../components/layout"
import BlogCard from "../components/postCard"
import SEO from "../components/seo"


const Wrapper = styled.div`
  padding-top: 50px;

  h1 {
    text-align: center;
    color: #fff;
  }

  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      max-width: 1024px;
    }
  }
`

const Tags = props => {
  const blogs = props.data.blog.edges
  console.log(blogs)
  return (
    <Layout>
      {/* <SEO /> */}
      <Wrapper>
        <ul>
      {blogs.map(blog => {
        return (
          <BlogCard
            {...blog.node}
            key={blog.node.id}
            size="small"
            link={`blog/${blog.node.slug.current}`}
          />
        )
      })}
      </ul>
      </Wrapper>
    </Layout>
  )
}

export default Tags

export const pageQuery = graphql`
  query TagQuery($tag: String!) {
    blog: allSanityPost(filter: {tags: {elemMatch: {name: {eq: $tag} }}}) {
      edges {
        node {
          publishedAt
          featured
          summary
          slug {
            current
          }
          title
          tags {
            id
            name
          }
          id
          mainImage {
              asset {
                fixed(width: 600, height: 200) {
                  ...GatsbySanityImageFixed
                }
                fluid(maxWidth: 400) {
                  ...GatsbySanityImageFluid
                }
              }
            }
        }
    }
    }
  }
`
